var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/subject"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.44 3.837h6.534a2.447 2.447 0 0 1 2.446 2.447v3.379M6 15h6m-6 2.252h4.845M6 12.655h2.525M17.855 21H6.144A3.146 3.146 0 0 1 3 17.854V6.146A3.146 3.146 0 0 1 6.146 3h3.533c.883 0 1.686.512 2.059 1.312l1.485 4.025h4.631A3.146 3.146 0 0 1 21 11.483v6.371A3.146 3.146 0 0 1 17.854 21Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/subject.66c8af5d8a6bcea6a33f7cf64e3ee736.svg";
export { ForwardRef as ReactComponent };